export default {
	wrongCurrentPassword: 279,
	wrongNewPasswordConfirm: 278,
	required: 300,
	maxLength: 304,
	internalError: 473,
	pageNotFound: 474,
	forbidden: 475,
	errorMessage: 476,
	cannotChangePasswordUseADFS: 751,
	deepLinkNotAvailableMessage: 840,
	deepLinkNotAvailable: 841,
	noResultFoundsBasedDeeplinkTitle: 1348,
	noResultFoundsBasedDeeplinkMessage: 1349,
	sessionDataExpired: 3177,
	guidAlreadyExists: 2329,
	permissionError: 8067,
	badRequest: 3221,
	wrongLogInUseAzureAd: 10390,
	cannotChangePasswordUseAzureAd: 10391,
	forbiddenDescription: 10712,
	badRequestDescription: 10713,
	sessionDataExpiredDescription: 10714,
	noEnvironmentAccess: 11452,
	requestAccess: 11453,
	pageNotFoundDescription: 13611,
	weakPassword: 14847,
	maintenanceWork: 16131,
	maintenanceWorkDescription: 16132,
};
